import { queryClient, store } from './App';
import { notification } from '~/ducks/snackbarNotifications';
import { logout } from './api/auth';

const loginNotification = () =>
  store.dispatch(
    notification({
      severity: 'info',
      message: 'Session expired. Please login again to continue',
      autoHideDuration: 99999,
      disableClickawayClose: true,
    })
  );

const clearAuthenticationData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('role');
  localStorage.removeItem('identity');
  localStorage.removeItem('justLoggedIn');
  queryClient.clear();
};

export default {
  login: async () => {
    console.log('login; do nothing on login');
  },
  logout: async () => {
    console.log('logging out');
    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) {
      console.log('querying back-end to log out');
      try {
        await logout(refreshToken);
        console.log('logout request successfully processed by back-end');
      } catch (err) {
        console.warn('logout request to back-end has failed with error', err);
      }
    }

    clearAuthenticationData();
    return Promise.resolve();
  },
  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      console.log(`HTTP response is ${status}; access error`);
      // No need to clear data here as it should be handled by axios interceptor's refreshAndRetry
    }
    return status === 403 ? Promise.reject() : Promise.resolve();
  },
  checkAuth: () => {
    if (
      !localStorage.getItem('identity') ||
      !localStorage.getItem('token') ||
      !localStorage.getItem('refreshToken') ||
      !localStorage.getItem('role')
    ) {
      console.log('not authenticated; data local storage is not complete');
      clearAuthenticationData();
      loginNotification();
      window.location.reload();
    }
    return Promise.resolve();
  },
  getPermissions: () => {
    const permissions = localStorage.role ? JSON.parse(localStorage.role).permissions : undefined;
    return permissions ? Promise.resolve(permissions) : Promise.reject();
  },
};
